import React from 'react'
import { Outlet } from 'react-router-dom'
import { Box, ThemeProvider } from '@mui/material'
import { useFeatureFlag } from '../../../utils/hooks/useFeatureFlag'
import Footer from '../Footer'
import Main from '../Main'
import useAppInsights from '../../../rsmCoreComponents/hooks/appInsights'
import { getHighContrast } from '../../../store/userSettings/userSettingsSlice'
import { accessibilityTheme, normalTheme } from '../../../styles/materialTheme'
import { useAppSelector } from '../../../utils/hooks'
import Popover from '../../Popover/Popover'
import ProfileModalContainer from '../../Profile/ProfileModal/ProfileModalContainer'
import WelcomeModal from '../../WelcomeModal/WelcomeModal'

const Layout = () => {
  const isHighContrast = useAppSelector(getHighContrast)
  const isUserProfileEnabled = useFeatureFlag('UserProfile')

  return (
    <ThemeProvider theme={isHighContrast ? accessibilityTheme : normalTheme}>
      <Popover />
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
        }}>
        <Main>
          <Outlet />
        </Main>
        <Footer />
      </Box>
      {isUserProfileEnabled && <ProfileModalContainer />}
      <WelcomeModal />
    </ThemeProvider>
  )
}

export default useAppInsights(Layout)
